<template>
  <ScreenAdapter>
    <div id="main">
      <Header />
      <Nav />
      <div class="platform-cover" :style="`background:url(${cover}) no-repeat center/cover`"></div>
      <div class="eol-main-container">
        <div class="thought-content" ref="111">
          <div class="content-header">
            <div class="text">习近平新时代中国特色社会主义思想</div>
          </div>
          <div class="content-box">
            <div class="thought-bg">
              <div class="thought-content">
                <div class="swiper-content" v-if="thoughtData && thoughtData.length > 0">
                  <swiper :options="thoughtSwiperOption">
                    <swiper-slide :style="`background-image: url('${item.photo}');`" v-for="item in thoughtData" :key="item.id" :data-id="item.id">
                    </swiper-slide>
                  </swiper>
                  <div class="swiper-pagination thought"></div>

                  <div class="swiper-button-next thought"></div>
                  <div class="swiper-button-prev thought"></div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="value-content" ref="112">
          <div class="content-header">
            <div class="text">社会主义核心价值观</div>
          </div>
          <div class="content-box">
            <div class="content-item" v-for="(item,index) in valueData" :key="index" :style="`background:url(${item.photo}) no-repeat center/cover`" @click="jumpDetail(item)"></div>
            <div class="flex-hide"></div>
          </div>
        </div>
        <div class="spirit-content" ref="113">
          <div class="content-header">
            <div class="text">精神信仰</div>
          </div>
          <div class="content-box">
            <div class="content-item" v-for="(item,index) in spiritData" :key="index" :style="`background:url(${item.photo}) no-repeat center/cover`" @click="jumpDetail(item)"></div>
            <div class="flex-hide"></div>
          </div>
        </div>
        <a target="_blank" :href="course_cover_info.url" class="course-banner" :style="`background:url(${course_cover_info.cover}) no-repeat center/cover`"></a>
      </div>
      <Footer />
    </div>
  </ScreenAdapter>

</template>

<script>
import Header from "@/components/Hzvtc/Header.vue"
import Nav from "@/components/Hzvtc/Nav.vue"
import Footer from "@/components/Hzvtc/Footer.vue"
import services from '../../../config/services'
import ScreenAdapter from "@/components/ScreenAdapter.vue"


export default {
  data () {
    let that = this
    return {
      cover: require("../../../assets/hzvtc/cover/value.png"),
      course_cover_info: {
        cover: require("../../../assets/hzvtc/cover/banner-spirit.png"), // 精神信仰VR系列资源
        url: "https://xuexi.jiaoyu.cn/center/100028/hzvtc/detail?id=341&key=value"
      },
      school_code: services.HZ_CODE,
      thoughtSwiperOption: {
        autoplay: {
          delay: 8000,
          disableOnInteraction: false
        },
        effect: "coverflow",
        loop: true,
        grabCursor: true,
        centeredSlides: true,
        slidesPerView: "auto",
        coverflowEffect: {
          rotate: 0,
          stretch: 350,
          depth: 150,
          modifier: 1,
          slideShadows: false,
        },
        preventClicksPropagation: false,
        navigation: {
          // 前进后退按钮 ,不同版本配置方式不同
          nextEl: `.swiper-button-next.thought`,
          prevEl: `.swiper-button-prev.thought`,
        },
        pagination: {
          el: `.swiper-pagination.thought`,
        },
        on: {
          click: function (v) {
            let id = v.target.getAttribute("data-id");
            if (id) {
              window.open(`/center/${that.school_code}/hzvtc/detail?id=${id}&key=value`, "_blank")
            }

          },
        },
      },
      thoughtData: [], // 习近平新时代中国特色社会主义思想
      valueData: [], // 社会主义核心价值观
      spiritData: [], // 精神信仰
    }
  },
  components: {
    Header,
    Nav,
    Footer,
    ScreenAdapter
  },
  mounted () {
    this.getListData()
  },
  methods: {
    async getListData () {
      // 习近平新时代中国特色社会主义思想
      await services.getCourseList({ page: 1, size: 100, category_id: "111", school_code: this.school_code }).then(res => {
        this.thoughtData = res.data.items
      })

      // 社会主义核心价值观
      await services.getCourseList({ page: 1, size: 6, category_id: "112", school_code: this.school_code }).then(res => {
        this.valueData = res.data.items
      })

      // 精神信仰
      await services.getCourseList({ page: 1, size: 3, category_id: "113", school_code: this.school_code }).then(res => {
        this.spiritData = res.data.items
      })
      await this.jumpPosition()

    },
    // 锚点定位
    jumpPosition () {
      let that = this
      let position = that.$route.query.id
      if (position) {
        that.$nextTick(() => {
          let topVal = this.$refs[position].getBoundingClientRect().top
          let element = document.getElementsByClassName("outContainer")[0]
          element.scrollTop = topVal - 100
        })
      }
    },
    // 跳转到详情
    jumpDetail (item) {
      window.open(`/center/${this.school_code}/hzvtc/detail?id=${item.id}&key=value`, "_blank")
    },
  },
}
</script>

<style lang="less" scoped>
#main {
  background: #fff;
}
.platform-cover {
  width: 100%;
  height: 510px;
}

.eol-main-container {
  width: 1400px;
  margin: 0 auto;
  padding: 64px 0 70px;
  .content-header {
    width: 1400px;
    margin: 0 auto 30px;
    font-weight: bold;
    font-size: 42px;
    color: #B61E2A;
    background: linear-gradient(0deg, #B61E2A 0%, #EF350A 100%);
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
    text-align: center;
    position: relative;
    z-index: 2;
    &::after {
      width: 1400px;
      margin-top: 16px;
      height: 35px;
      content: "";
      display: block;
      background-image: url("../../../assets/hzvtc/list/hzdx-title.png");
      background-size: cover;
      background-position: center;
      // position: absolute;
    }
  }
  .content-box {
    position: relative;
    z-index: 10;
    display: flex;
    justify-content: space-between;
    flex-wrap: wrap;
    .content-item {
      width: 446px;
      height: 251px;
      cursor: pointer;
      margin-bottom: 30px;
    }
    .flex-hide {
      flex: 0 0 446px;
      visibility: hidden;
      display: block;
    }
  }

  .thought-content {
    position: relative;
    &::before {
      content: '';
      display: inline-block;
      width: 1920px;
      top: 0;
      left: 50%;
      transform: translateX(-50%);
      height: 1322px;
      position: absolute;
      background: url('../../../assets/hzvtc/list/value-t-bg.png') no-repeat
        center/cover;
    }
     .content-header {
    margin: 0 auto;
  }

    .content-box {
      .swiper-slide {
        width: 863px !important;
        height: 485px !important;
        .cover {
          width: 100%;
          height: 100%;
        }
      }

      ::v-deep .swiper-pagination {
        width: 100%;
        display: flex;
        align-items: center;
        justify-content: center;
        position: absolute;
        bottom: -32px;
        left: 50%;
        transform: translateX(-50%);
      }
      ::v-deep .swiper-pagination-bullet {
        width: 7px;
        height: 7px;
        background: #b61e2a;
        border: 1px solid #ffffff;
        opacity: 0.5;
        border-radius: 50%;
        display: block;
        transition: all 0.3s;
        margin-right: 4px;
      }

      ::v-deep .swiper-pagination-bullet.swiper-pagination-bullet-active {
        width: 13px;
        height: 7px;
        background: #b61e2a;
        border: 1px solid #ffffff;
        border-radius: 3px;
        opacity: 1;
        margin-right: 7px;
      }
    }
  }
  .value-content {
    position: relative;
    .content-header {
      margin-bottom: 40px;
    }
    &::before {
      content: '';
      display: inline-block;
      width: 1920px;
      bottom: -660px;
      left: 50%;
      transform: translateX(-50%);
      height: 1322px;
      position: absolute;
      background: url('../../../assets/hzvtc/list/value-c-bg.png') no-repeat
        center/cover;
    }
  }
  .spirit-content {
    .content-header {
      margin: 50px 0 40px;
    }
  }
}

.thought-bg {
  background-position: center;
  background-size: cover;
  padding: 48px 0 65px;
  .thought-content {
    width: 1400px;
    margin: 0 auto;
    .swiper-content {
      position: relative;
      width: 100%;
      height: 542px;
      display: flex;
      align-items: center;
      .swiper-container {
        height: 100%;
        .swiper-wrapper {
          .swiper-slide {
            width: 863px;
            height: 485px;
            background: #fff;
            background-size: 100% auto;
            background-position: center;
            cursor: pointer;
            &.swiper-slide-active {
              -webkit-transform: translate3d(0px, 0px, 0px) rotateX(0deg)
                rotateY(0deg) !important;
              -moz-transform: translate3d(0px, 0px, 0px) rotateX(0deg)
                rotateY(0deg) !important;
              -o-transform: translate3d(0px, 0px, 0px) rotateX(0deg)
                rotateY(0deg) !important;
              -ms-transform: translate3d(0px, 0px, 0px) rotateX(0deg)
                rotateY(0deg) !important;
              transform: translate3d(0px, 0px, 0px) rotateX(0deg) rotateY(0deg) !important;
              border: 2px solid red;
            }
          }
        }
      }
      /deep/ .swiper-pagination {
        bottom: 10px;
        width: 100%;
        .swiper-pagination-bullet {
          width: 10px;
          height: 10px;
          background: #ffbe8f;
          border-radius: 50%;
          margin: 0 5px;
        }
        .swiper-pagination-bullet.swiper-pagination-bullet-active {
          width: 10px;
          height: 10px;
          background: #b70000;
          border-radius: 50%;
        }
      }
      .swiper-button-next,
      .swiper-button-prev {
        flex-shrink: 0;
        background-size: cover;
        z-index: 100;
        position: absolute;
        top: 50%;
        transform: translateY(-50%);
        cursor: pointer;
        width: 40px;
        height: 40px;
      }
      .swiper-button-prev {
        left: -84px;
        background: url('../../../assets/hzvtc/list/value-prev.png') no-repeat
          center/cover;
      }
      .swiper-button-next {
        right: -84px;
        background: url('../../../assets/hzvtc/list/value-next.png') no-repeat
          center/cover;
      }
    }
  }
}
::v-deep .footer-container {
  position: relative;
  z-index: 10;
}
.course-banner {
  display: block;
  width: 100%;
  height: 90px;
  margin: 0 0 0;
  position: relative;
  z-index: 100;
}
</style>